import React from "react"
import ModalFormUI from "../../../widgets/form/ModalFormUI"
import InputDateUI from "../../../widgets/form/InputDateUI"
import InputCheckBoxUI from "../../../widgets/form/InputCheckBoxUI";

const InterestCollection2ModalUI = ({
  context, successMsg, errorList, setErrorList,
  updateMode, onSubmit, submitted, onCancelClick,
  collectionDate, onCollectionDateChange, collectionDateError, setCollectionDateError,
  collected, onCollectedChange
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Interest payment'
    buttonLabel='Pay'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputDateUI context={context} type='date' name='collectionDate'
      label='Interest collection date'
      selectedDateISO={collectionDate} onChange={onCollectionDateChange}
      error={collectionDateError} setError={setCollectionDateError}
      help='Invoice will be marked paid and interest payment will be made to Clime'
    />
    {/* <InputCheckBoxUI label='Collected' name='collected'
      onChange={onCollectedChange} checked={collected}
    /> */}
  </ModalFormUI>

export default InterestCollection2ModalUI;
